(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttns-events"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ttns-events')) {
  customElements.define('ttns-events', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.today = new Intl.DateTimeFormat('en-CA', {timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
      this.month = this.today.slice(0,7);
      this.view = 'month';
      this.cards = [...this.querySelectorAll('[data-event]')];
      this.cards.forEach(card => card.originalSchedule = card.querySelector('[data-schedule]').textContent);
      this.querySelector('.ttns-events__toolbar').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1));
      this.querySelector('[data-next]').addEventListener('click',()=>this.move(1));
      this.querySelector('[data-today-button]').addEventListener('click',()=>{this.month=this.today.slice(0,7);this.view='month';this.render();});
      this.querySelectorAll('[data-view]').forEach(button=>button.addEventListener('click',()=>{this.view=button.dataset.view;this.render();}));
      this.querySelector('[data-grid]').addEventListener('click',event=>{
        const link=event.target.closest('a');
        if (!link) return;
        const card=this.querySelector(link.getAttribute('href'));
        if(card){card.hidden=false;requestAnimationFrame(()=>card.focus({preventScroll:true}));}
      });
      this.onHash=()=>this.openHash();
      window.addEventListener('hashchange',this.onHash);
      this.render();this.openHash();
    }
    disconnectedCallback(){window.removeEventListener('hashchange',this.onHash);}
    iso(date){return date.toISOString().slice(0,10);}
    parse(value){if(!/^\d{4}-\d{2}-\d{2}$/.test(value))return null;const date=new Date(value+'T12:00:00Z');return Number.isFinite(+date)&&this.iso(date)===value?date:null;}
    pretty(value){const date=this.parse(value);return date?date.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}):value;}
    move(step){const date=this.parse(this.month+'-01');date.setUTCMonth(date.getUTCMonth()+step);this.month=this.iso(date).slice(0,7);this.view='month';this.render();}
    closed(day){return this.cards.some(c=>c.dataset.closure==='true'&&c.dataset.start<=day&&(c.dataset.end||c.dataset.start)>=day);}
    dates(card){
      const data=card.dataset;
      if(data.weekly==='true'){
        const date=this.parse(this.month+'-01'),dates=[];
        while(this.iso(date).startsWith(this.month)){const day=this.iso(date);if(date.getUTCDay()===4&&!this.closed(day))dates.push(day);date.setUTCDate(date.getUTCDate()+1);}return dates;
      }
      if(data.dates.trim())return data.dates.split(',').map(s=>s.trim()).filter(s=>this.parse(s)&&s.startsWith(this.month));
      const start=this.parse(data.start),end=this.parse(data.end||data.start),dates=[];
      if(!start||!end)return dates;
      const date=this.parse(this.month+'-01');
      while(this.iso(date).startsWith(this.month)){const day=this.iso(date);if(day>=data.start&&day<=(data.end||data.start))dates.push(day);date.setUTCDate(date.getUTCDate()+1);}return dates;
    }
    openHash(){
      let hash=location.hash;
      if(hash.startsWith('#tsc_event=')){const params=new URLSearchParams(hash.slice(1));hash='#event-'+params.get('tsc_event');}
      const id=hash.slice(1),card=this.cards.find(c=>c.id===id);
      if(card){if(card.hidden){this.view='all';this.render();}card.scrollIntoView();card.focus({preventScroll:true});}
    }
    nextDate(card){
      if(card.dataset.weekly==='true'){
        const date=this.parse(this.today);
        for(let i=0;i<366;i++){const day=this.iso(date);if(date.getUTCDay()===4&&!this.closed(day))return day;date.setUTCDate(date.getUTCDate()+1);}
      }
      if(card.dataset.dates.trim()){
        const dates=card.dataset.dates.split(',').map(d=>d.trim()).filter(d=>this.parse(d)).sort();
        return dates.find(d=>d>=this.today)||dates[0]||'9999-12-31';
      }
      return card.dataset.start||'9999-12-31';
    }
    range(card){return card.dataset.weekly!=='true'&&!card.dataset.dates.trim()&&this.parse(card.dataset.start)&&this.parse(card.dataset.end)&&card.dataset.end>card.dataset.start;}
    eventLink(card,label){
      const link=document.createElement('a');link.href='#'+card.id;link.setAttribute('aria-label',label);link.title=label;link.dataset.activity=card.dataset.activity;return link;
    }
    render(){
      const monthDate=this.parse(this.month+'-01');
      this.querySelector('[data-month]').textContent=monthDate.toLocaleDateString('en-US',{month:'long',year:'numeric',timeZone:'UTC'});
      this.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===this.view)));
      const grid=this.querySelector('[data-grid]');grid.replaceChildren();grid.hidden=this.view==='all';
      const occurrences=new Map(this.cards.map(card=>[card,this.dates(card)]));
      const sortDate=card=>this.view==='month'?(this.range(card)?card.dataset.start:(occurrences.get(card).find(d=>this.month===this.today.slice(0,7)?d>=this.today:true)||occurrences.get(card)[0]||this.nextDate(card))):this.nextDate(card);
      const ordered=[...this.cards].sort((a,b)=>sortDate(a).localeCompare(sortDate(b))||this.cards.indexOf(a)-this.cards.indexOf(b));
      const list=this.querySelector('.ttns-events__list');let visible=0;
      ordered.forEach(card=>{
        const dates=occurrences.get(card);card.hidden=this.view==='month'&&dates.length===0;if(!card.hidden)visible++;
        list.append(card);
        if(card.dataset.dates.trim()){
          const labelDate=this.view==='month'&&dates.length?dates[0]:this.nextDate(card),date=this.parse(labelDate);
          if(date){const label=card.querySelector('[data-date-label]');label.textContent=date.toLocaleDateString('en-US',{month:'short',day:'numeric',timeZone:'UTC'});label.nextElementSibling.textContent=date.getUTCFullYear();}
        }
        const schedule=card.querySelector('[data-schedule]');
        schedule.textContent=card.dataset.weekly==='true'&&this.view==='month'?dates.map(d=>this.pretty(d)).join(' · ')+' — '+this.labels.weekly:card.dataset.dates.trim()&&this.view==='month'?dates.map(d=>this.pretty(d)).join(' · ')+' — '+this.labels.recurring:card.originalSchedule;
      });
      this.querySelector('[data-empty]').hidden=visible>0;
      const weekdays=document.createElement('div');weekdays.className='ttns-events__weekdays';
      this.labels.days.forEach(label=>{const cell=document.createElement('div');cell.className='ttns-events__weekday';cell.textContent=label;weekdays.append(cell);});grid.append(weekdays);
      const first=new Date(monthDate);first.setUTCDate(first.getUTCDate()-(first.getUTCDay()+6)%7);
      const ranges=ordered.filter(card=>this.range(card)&&occurrences.get(card).length).sort((a,b)=>a.dataset.start.localeCompare(b.dataset.start)||this.cards.indexOf(a)-this.cards.indexOf(b));
      const laneEnds=[],laneFor=new Map();
      ranges.forEach(card=>{let lane=laneEnds.findIndex(end=>end<card.dataset.start);if(lane<0)lane=laneEnds.length;laneEnds[lane]=card.dataset.end;laneFor.set(card,lane);});
      for(let weekStart=new Date(first);this.iso(weekStart)<=this.month+'-31';weekStart.setUTCDate(weekStart.getUTCDate()+7)){
        const days=Array.from({length:7},(_,i)=>{const d=new Date(weekStart);d.setUTCDate(d.getUTCDate()+i);return this.iso(d);});
        if(!days.some(day=>day.startsWith(this.month)))break;
        const segments=ranges.filter(card=>days.some(day=>day.startsWith(this.month)&&day>=card.dataset.start&&day<=card.dataset.end));
        const lanes=[...new Set(segments.map(card=>laneFor.get(card)))].sort((a,b)=>a-b);
        const week=document.createElement('div');week.className='ttns-events__week';week.style.gridTemplateRows='28px '+'24px '.repeat(lanes.length)+'minmax(42px,auto)';
        days.forEach((day,col)=>{
          const active=day.startsWith(this.month),cell=document.createElement('div');
          cell.className='ttns-events__day'+(!active?' ttns-events__day--blank':'')+(day===this.today?' ttns-events__day--today':'');cell.style.gridColumn=String(col+1);cell.style.gridRow='1 / -1';week.append(cell);
          if(!active)return;
          const number=document.createElement('time');number.className='ttns-events__number';number.dateTime=day;number.textContent=Number(day.slice(-2));number.style.gridColumn=String(col+1);number.style.gridRow='1';week.append(number);
          const points=document.createElement('div');points.className='ttns-events__points';points.style.gridColumn=String(col+1);points.style.gridRow=String(lanes.length+2);
          ordered.filter(card=>!this.range(card)&&occurrences.get(card).includes(day)).forEach(card=>{
            const title=card.querySelector('h3').textContent,link=this.eventLink(card,this.pretty(day)+': '+title);link.className='ttns-events__point';
            const name=document.createElement('span');name.className='ttns-events__event-name';name.textContent=title;
            const dot=document.createElement('span');dot.className='ttns-events__count';dot.textContent='●';link.append(name,dot);points.append(link);
          });week.append(points);
        });
        segments.forEach(card=>{
          const cols=days.map((day,i)=>day.startsWith(this.month)&&day>=card.dataset.start&&day<=card.dataset.end?i:-1).filter(i=>i>=0);
          const title=card.querySelector('h3').textContent,link=this.eventLink(card,title+' · '+this.pretty(card.dataset.start)+' – '+this.pretty(card.dataset.end));
          link.className='ttns-events__range';
          link.style.gridColumn=(cols[0]+1)+' / '+(cols[cols.length-1]+2);link.style.gridRow=String(lanes.indexOf(laneFor.get(card))+2);
          link.textContent=(card.dataset.start<days[cols[0]]?'‹ ':'')+title+(card.dataset.end>days[cols[cols.length-1]]?' ›':'');week.append(link);
        });grid.append(week);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
